<template>
  <div>
    <p class="small">{{ $t('LoanApplicationTimeline.verificationTitle') }}</p>
    <div class="alert alert-warning small rounded border mb-0 text-center px-0 py-2">
      <div>{{$t('LoanApplicationTimeline.verificationShouldTakeShortTime')}}</div>
      <button class="btn btn-sm btn-primary mt-3 mb-2 px-3" @click="startGetID()">{{$t('LoanApplicationTimeline.verificationStart')}}</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IdentityVerificationRequiredComponent',
  methods: {
    startGetID() {
      this.$emit('on-verification-start')
    }
  }
}
</script>
